// extracted by mini-css-extract-plugin
export default {"fileUploadContainer":"FileUpload_fileUploadContainer__yTasN","fileUploadButton":"FileUpload_fileUploadButton__+ZRHv","uploadedFile":"FileUpload_uploadedFile__pZLoE"};